import { useState, useEffect } from 'react';

export const useElementSize = (ref: React.RefObject<HTMLElement>): number => {
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const element = ref.current;
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                setHeight(entry.contentRect.height);
            }
        });
        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return height;
};
